function debounce(fn, wait) {
  let t
  return (...args) => {
    clearTimeout(t)
    t = setTimeout(() => fn.apply(this, args), wait)
  }
}

function fetchConfig(type = "json", method = "POST") {
  return {
    method,
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  }
}

class CartRemoveButton extends HTMLElement {
  constructor() {
    super()
    this.addEventListener("click", (event) => {
      event.preventDefault()
      this.closest("cart-items").updateQuantity(this.dataset.index, 0)
    })
  }
}

customElements.define("cart-remove-button", CartRemoveButton)

class CartItems extends HTMLElement {
  constructor() {
    super()

    this.lineItemStatusElement = document.getElementById(
      "shopping-cart-line-item-status"
    )

    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]')
    ).reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0)

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event)
    }, 300)

    this.addEventListener("change", this.debouncedOnChange.bind(this))

    document.documentElement.addEventListener("cart:refresh", () => {
      this.refreshCart()
    })

    document.documentElement.addEventListener("cart:open", () => {
      document.querySelector(".mini-cart").classList.add("-open")
    })
  }

  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute("name")
    )
  }

  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-contents",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer").dataset.id,
        selector: "#main-cart-footer",
      },
    ]
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line)

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    })

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text()
      })
      .then(async (state) => {
        const parsedState = JSON.parse(state)
        this.classList.toggle("is-empty", parsedState.item_count === 0)
        const cartFooter = document.getElementById("main-cart-footer")

        if (cartFooter)
          cartFooter
            .querySelector(".container")
            .classList.toggle("is-empty", parsedState.item_count === 0)

        try {
          if (!parsedState.sections) {
            parsedState.sections = await fetch(`${Shopify.routes.root + 'cart'}?sections=${this.getSectionsToRender().map(section => section.id)}`).then(res => res.json())
          }
        } catch (error) {}

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id)

          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          )
        })

        document.getElementById("mini-cart-badge").textContent =
          parsedState.item_count

        this.updateLiveRegions(line, parsedState.item_count)
        const lineItem = document.getElementById(`CartItem-${line}`)
        if (lineItem && lineItem.querySelector(`[name="${name}"]`))
          lineItem.querySelector(`[name="${name}"]`).focus()
        this.disableLoading()
      })
      .catch((res) => {
        this.querySelectorAll(".loading-overlay").forEach((overlay) =>
          overlay.classList.add("hidden")
        )
        document.getElementById("cart-errors").textContent =
          window.cartStrings.error
        this.disableLoading()

        console.log(res)
      })
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      document
        .getElementById(`Line-item-error-${line}`)
        .querySelector(".cart-item__error-text").innerHTML =
        window.cartStrings.quantityError.replace(
          "[quantity]",
          document.getElementById(`Quantity-${line}`).value
        )
    }

    this.currentItemCount = itemCount
    this.lineItemStatusElement.setAttribute("aria-hidden", true)

    const cartStatus = document.getElementById("cart-live-region-text")
    cartStatus.setAttribute("aria-hidden", false)

    setTimeout(() => {
      cartStatus.setAttribute("aria-hidden", true)
    }, 1000)

    document.getElementById("mini-cart-badge").textContent = itemCount
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML
  }

  enableLoading(line) {
    document
      .getElementById("main-cart-items")
      .classList.add("cart__items--disabled")
    this.querySelectorAll(`#CartItem-${line} .loading-overlay`).forEach(
      (overlay) => overlay.classList.remove("hidden")
    )
    document.activeElement.blur()
    this.lineItemStatusElement.setAttribute("aria-hidden", false)
  }

  disableLoading() {
    document
      .getElementById("main-cart-items")
      .classList.remove("cart__items--disabled")
  }

  refreshCart() {
    const sections = this.getSectionsToRender()
      .map((section) => section.section)
      .join(",")

    fetch(`/?sections=${sections}`, { ...fetchConfig("json", "GET") })
      .then((response) => {
        return response.text()
      })
      .then(async (state) => {
        const parsedState = JSON.parse(state)

        const badgeCount = new DOMParser()
          .parseFromString(parsedState["cart-icon-bubble"], "text/html")
          .querySelector("span")
        const itemCount = badgeCount ? parseInt(badgeCount.textContent) : 0
        document.getElementById("mini-cart-badge").textContent = itemCount

        this.classList.toggle("is-empty", itemCount === 0)
        const cartFooter = document.getElementById("main-cart-footer")

        if (cartFooter)
          cartFooter
            .querySelector(".container")
            .classList.toggle("is-empty", itemCount === 0)

        try {
          if (!parsedState.sections) {
            parsedState.sections = await fetch(`${Shopify.routes.root + 'cart'}?sections=${this.getSectionsToRender().map(section => section.id)}`).then(res => res.json())
          }
        } catch (error) {}

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id)

          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          )
        })
      })
      .catch((res) => {
        console.log(res)
      })
  }
}

customElements.define("cart-items", CartItems)
